import { createAsyncThunk } from "@reduxjs/toolkit";
import magnifiAPI from "services/api/magnifi";

export const getHealthMetrics = createAsyncThunk("channelSummary/getHealthLogs", async (payload) => {
  try {
    const response = await magnifiAPI.getHealthMetrics(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
export const getHealthAlerts = createAsyncThunk("channelSummary/getHealthAlerts", async (payload) => {
  try {
    const response = await magnifiAPI.getHealthAlerts(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
